<script>
export default {
  name: "tooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      validator: function(value) {
        return ['bottom-left', 'bottom-right'].indexOf(value) !== -1;
      },
      default: "bottom-left",
    }
  },
  data: () => ({
    show: false,
  }),
  methods: {
    showTooltip() {
      this.show = true;
    },
    hideTooltip() {
      this.show = false;
    },
  },
};
</script>

<template>
    <div class="tooltip" @mouseover="showTooltip" @mouseout="hideTooltip">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 25 25" fill="none">
        <rect width="24" height="24" transform="translate(0.539307 0.772217)" fill="white" fill-opacity="0.01"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5393 20.7722C10.4176 20.7722 8.38274 19.9294 6.88245 18.4291C5.38216 16.9288 4.53931 14.8939 4.53931 12.7722C4.53931 10.6505 5.38216 8.61565 6.88245 7.11536C8.38274 5.61507 10.4176 4.77222 12.5393 4.77222C14.661 4.77222 16.6959 5.61507 18.1962 7.11536C19.6965 8.61565 20.5393 10.6505 20.5393 12.7722C20.5393 14.8939 19.6965 16.9288 18.1962 18.4291C16.6959 19.9294 14.661 20.7722 12.5393 20.7722ZM12.5393 12.2722C12.2741 12.2722 12.0197 12.3776 11.8322 12.5651C11.6447 12.7526 11.5393 13.007 11.5393 13.2722V15.7722C11.5393 16.0374 11.6447 16.2918 11.8322 16.4793C12.0197 16.6669 12.2741 16.7722 12.5393 16.7722C12.8045 16.7722 13.0589 16.6669 13.2464 16.4793C13.4339 16.2918 13.5393 16.0374 13.5393 15.7722V13.2722C13.5393 13.007 13.4339 12.7526 13.2464 12.5651C13.0589 12.3776 12.8045 12.2722 12.5393 12.2722ZM12.5393 11.1472C12.904 11.1472 13.2537 11.0024 13.5116 10.7445C13.7694 10.4866 13.9143 10.1369 13.9143 9.77222C13.9143 9.40754 13.7694 9.05781 13.5116 8.79994C13.2537 8.54208 12.904 8.39722 12.5393 8.39722C12.1746 8.39722 11.8249 8.54208 11.567 8.79994C11.3092 9.05781 11.1643 9.40754 11.1643 9.77222C11.1643 10.1369 11.3092 10.4866 11.567 10.7445C11.8249 11.0024 12.1746 11.1472 12.5393 11.1472Z" fill="#42526E"/>
      </svg>
      <div v-if="show" :class="`tooltip__container tooltip__container--${position}`">
        <p>{{ text }}</p>
      </div>
    </div>
</template>

<style lang="scss" scoped>
.tooltip {
  margin: 0 4px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;

  &__container {
    position: absolute;
    min-width: 360px;
    max-width: 360px;
    padding: 1rem;
    background-color: #fff;
    border-radius: 0.25rem;
    border: 1px solid var(--neutro-70, #A5ADBA);
    z-index: 9999;

    &--bottom-left {
      left: 25px;

      @media (max-width: 768px) {
        left: -65px;
      }

      @media (max-width: 375px) {
        left: -76px;
      }
    }

    &--bottom-right {
      right: 15px;

      @media (max-width: 768px) {
        right: -79px;
      }

      @media (max-width: 375px) {
        right: -58px;
      }
    }

    p {
      color: #172B4D;
      font-family: Roboto;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 19.2px */
      letter-spacing: 0.32px;
    }
  }
}
</style>
